// extracted by mini-css-extract-plugin
module.exports = {"date":"Date_date__2F1Hz","icon":"Date_icon__nW3vg","text":"Date_text__2Yxh7"};